$(document).ready(function(e){

	if ($(document).find('.field.dob')){
		$(document).find('.field.dob').each(function(){

			var dom = $(this);
			var over65Field = false;
			if ($(document).find(':input.over65')){
				over65Field = $(document).find(':input.over65');
			}

			var under_18_error_msg = "Members aged below 18 are unable to use this online form.";

			// initiate and configure date dropdowns plugin
			// https://www.jqueryscript.net/time-clock/Easy-Customizable-jQuery-Dropdown-Date-Picker-Plugin.html
			var input = dom.find('input').dateDropdowns({
				defaultDateFormat: "dd/mm/yyyy",
				submitFormat: "dd/mm/yyyy",
				monthFormat: "short",
				daySuffixes: false,
				minAge: 18,
				maxAge: 108,
				required: true
			});			

			PopulateDropdownsOnLoad(input,dom);

			var dob_field = dom.find('input[name="DateOfBirth"].dob');
			if (dob_field.length > 0){
				dob_field.rules(
					"add", {
						eighteenYearsAgo: true,
						messages: {						
							eighteenYearsAgo: under_18_error_msg
						}
					}
				);
			}
			
			input.change(function(){
				var dateText = $(this).val();
				if(dateText != null || dateText != ''){
					
					if(AllDropdownsFull(dom)){
						// resolve issue of minAge only applying to year, not day/month
						// see: https://github.com/IckleChris/jquery-date-dropdowns/issues/23
						if(Under18YearsAgo(dateText)){
							if($('#' + $(this).attr("id") + '-error').length){
								$('#' + $(this).attr("id") + '-error').html(under_18_error_msg);
							} else {
								$("<div/>")
									.attr('id',$(this).attr("id") + '-error')
									.attr('class','error')
									.html(under_18_error_msg)
									.appendTo($(this).parents('.field')); 
							}
							dom.find('.day, .month, .year').removeClass('valid').addClass('invalid error').attr('aria-invalid',true);
						}else {
							dom.find('.day, .month, .year').removeClass('invalid error').addClass('valid').attr('aria-invalid',false);
							$('#' + $(this).attr("id") + '-error').remove();
						}
					}
					if(over65Field){ // update hidden "Over65" field when date is selected
						if (Over65YearsAgo(dateText)){
							over65Field.val('Yes').trigger('change');
						}else {
							over65Field.val('No').trigger('change');
						}
					}
				}
			});
		});

		function Under18YearsAgo(dateText){
			var under18 = true;
			var eighteenYearsAgo = new Date();
			eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear()-18);
			eighteenYearsAgo.setDate(eighteenYearsAgo.getDate()); // add one more day (accounts for birthday of today)

			// Convert human-friendly dd/mm/yyyy to js-friendly mm/dd/yyyy
			var inputDate_parts = dateText.split("/");
			var inputDate = new Date(inputDate_parts[2], inputDate_parts[1] - 1, inputDate_parts[0]); // month is 0-based
			if (inputDate < eighteenYearsAgo){
				under18 = false;
			}
			return under18;
		}

		function Over65YearsAgo(dateText){
			var sixtyFiveYearsAgo = new Date();
			sixtyFiveYearsAgo.setFullYear(sixtyFiveYearsAgo.getFullYear()-65);
			sixtyFiveYearsAgo.setDate(sixtyFiveYearsAgo.getDate()+1); // add one more day (accounts for birthday of today)

			// Convert human-friendly dd/mm/yyyy to js-friendly mm/dd/yyyy
			var inputDate_parts = dateText.split("/");
			var inputDate = new Date(inputDate_parts[2], inputDate_parts[1] - 1, inputDate_parts[0]); // month is 0-based

			if (inputDate < sixtyFiveYearsAgo){
				return true;
			}else {
				return false;
			}
		}

		function AllDropdownsFull(wrapper){
			var dropdowns = wrapper.find('select');
			var complete = true;
			dropdowns.each(function(){
				if(!$(this).val()){
					complete = false;
				}
			});
			if(complete){
				return true;
			}
		}

		function PopulateDropdownsOnLoad(input,wrapper){
			if(input.val()){
				var inputDate_parts = input.val().split("/");
				var dropdowns = wrapper.find('select');
				dropdowns.each(function(){
					if($(this).is('.day')){
						$(this).val(inputDate_parts[0]);
					}
					if($(this).is('.month')){
						$(this).val(inputDate_parts[1]);
					}
					if($(this).is('.year')){
						$(this).val(inputDate_parts[2]);
					}
				});
			}
		}

	}
});